export function extractLinks(str) {
  // Regex for detecting http(s) and www links
  const urlRegex = /\b((https?:\/\/|www\.)[^\s]+)/gi;
  const matches = [];
  let match;

  while ((match = urlRegex.exec(str)) !== null) {
    matches.push({
      start: match.index,
      end: match.index + match[0].length
    });
  }

  return {
    original: str,
    links: matches
  };
}